import adminDashboardReducer from './pages/dashboard/adminDashboardReducer';
import countryReducer from './pages/country/countryReducer';
import categoryReducer from './pages/category/categoryReducer';
import stateReducer from './pages/state/stateReducer';
import cityReducer from './pages/city/cityReducer';
import usersReducer from './pages/users/usersReducer';
import rulesReducer from './pages/rules/rulesReducer';
import permissionsReducer from './pages/permissions/permissionsReducer';

export default {
    dashboard_admin: adminDashboardReducer,
    country: countryReducer,
    category: categoryReducer,
    state: stateReducer,
    city: cityReducer,
    users: usersReducer,
    rules: rulesReducer,
    permissions: permissionsReducer
};